import { UPLOAD_IMAGE_DATA } from '../actions/types';

export const addUploadImageDatasource = uploadImageDatasource => ({
  type: UPLOAD_IMAGE_DATA,
  payload: uploadImageDatasource,
});